import { useRoomChangeDisable } from "@/components/features/items/edit/plan/_shared/ui/components/room-change-disable/hooks/use-room-change-disable";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanRoomChangeDisable = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { roomChangeDisable } = viewModel;

	return useRoomChangeDisable({ roomChangeDisable, onSetViewModel });
};
